(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-customers-login"]) return;
  try {
    
          let redirectLocation = "https://www.ecri.org/members/register/"

          if (window.location.search) {
            redirectLocation += window.location.search;
          }

          setTimeout(()=>{
            window.location.replace(redirectLocation);
          }, 3000)
          
        
  } catch(e) { console.error(e); }
})();
})();
